<template>
  <section class="root">
    <HubSpotForm :form-id="blok.form_id" :ignore="blok.ignore_fields" :max-width="blok.form_max_width" />
  </section>
</template>

<script>
import cms from "@/mixins/cms.js";
export default {
  mixins: [cms],
  name: "cms-hubspot-form",
  data() {
    return {
      busy: true,
      error: false,
      definition: {},
      formError: false,
      formSuccess: false,
      formSubmitting: false,
      dumpDefinition: false, // if true, form definition will be dumped in pre tag (dev purposes)
    }
  },
  // watch: {
  //   'blok.form_id': function (newVal, oldVal) {
  //     this.fetchForm();
  //   }
  // },
  async fetch() {
    // await this.fetchForm()
  },
  methods: {
    async fetchForm() {
      // try {
      //   this.busy = true;
      //   this.error = false;
      //   // const response = await this.$api.get(`public_api/hubspot/forms/${this.blok.form_id}`)
      //   this.definition = response.data.results;
      // } catch (error) {
      //   this.error = true;
      // } finally {
      //   this.busy = false;
      // }
    },
    // toggleHiddenCheck(e) {
    //   const find = e.target.getAttribute('name') + "--hidden";
    //   const hidden = document.getElementById(find);
    //   hidden.disabled = e.target.checked;
    // },
    // ping() {
    //   if (this.$config.LEA_ID) {
    //     const at_gd = this.$store.state.at_gd;
    //     if (at_gd) {
    //       const url = `https://cnv.adt632.com/t/t?t=4&tk=1&am=0&c=CHF&ti=0&tp=${this.blok.tp}&trt=4&ss=1&ap=1697206533&at_gd=${at_gd}`;
    //       fetch(url);
    //     }
    //   }
    // },
    onSubmit(e) {
      if (this.blok.tp != "") {
        this.ping();
      }
      const hsf = {
        context: {
          hutk: this.hutK,
          pageUri: this.$config.BASE_URL + this.$route.path.slice(1),
          pageName: this.blok.page_name || "unknown"
        },
        fields: []
      }
      const data = new FormData(this.$refs.hsform);
      for (const pair of data.entries()) {
        hsf.fields.push({
          objectTypeId: "0-1",
          name: pair[0],
          value: pair[1],
        })
      }


      this.formError = false;
      this.formSuccess = false;
      this.formSubmitting = true;

      // Can uncomment for testing purposes
      // setTimeout(() => {
      //   this.formSubmitting = false;
      //   this.formSuccess = true;
      //   setTimeout(() => {
      //     this.formSuccess = false;
      //   }, 2000)
      // }, 2000)
      // return;

      fetch(this.formURL, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(hsf) })
        .then((response) => response.json())
        .then((data) => {
          if (data.status == "error") {
            this.formError = true;
            this.formSubmitting = false;
          } else {
            this.formSuccess = true;
            this.formSubmitting = false;
            setTimeout(() => {
              this.$refs.hsform.reset()
              this.formSuccess = false;
              this.$emit("cms:form-submitted")
            }, 3000)
          }
        })
        .catch((error) => console.error(error));
    }
  },
}
</script>
